import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import Helmet from 'react-helmet';

import { SharedHeadTitleTag_metadata } from './__generated__/SharedHeadTitleTag_metadata.graphql';

type Props = { metadata: SharedHeadTitleTag_metadata };

const SharedHeadTitleTagComponent: FC<Props> = ({ metadata }) => {
    return <Helmet title={metadata.title || ''} />;
};

export const SharedHeadTitleTag = createFragmentContainer(SharedHeadTitleTagComponent, {
    metadata: graphql`
        fragment SharedHeadTitleTag_metadata on MetaData {
            title
        }
    `,
});
